// reducers/partnerReducer.js

import { SET_PARTNER_SMS_CONFIG } from "../Action/partnerSmsConfigAction";

const initialState = {
  partnerSmsConfig: null,
};

const partnerSmsConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PARTNER_SMS_CONFIG:
      return {
        ...state,
        partnerSmsConfig: action.payload,
      };
    default:
      return state;
  }
};

export default partnerSmsConfigReducer;
